import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <React.StrictMode>
    <App
      url={{
        api: 'http://apiv3.psiline.ro:9000/ajax.php',
        download: 'http://apiv3.psiline.ro:9000/download.php',
        static: 'http://apiv3.psiline.ro:9000/static/'
      }}
    />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
